import { render, staticRenderFns } from "./AiCursor.vue?vue&type=template&id=ccb4cfde&scoped=true&"
import script from "./AiCursor.vue?vue&type=script&lang=js&"
export * from "./AiCursor.vue?vue&type=script&lang=js&"
import style0 from "./AiCursor.vue?vue&type=style&index=0&id=ccb4cfde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb4cfde",
  null
  
)

export default component.exports